import { render, staticRenderFns } from "./ClinicPrefsEditCategories.vue?vue&type=template&id=6877a0c3"
import script from "./ClinicPrefsEditCategories.vue?vue&type=script&lang=js"
export * from "./ClinicPrefsEditCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports